<template>
    <MainContainer>
        <div class="fibu-buchungsstapel-vorlage">
            <h2>
                <template v-if="isNew">Neue Vorlage für Buchungsstapel ID {{ id }} erstellen</template>
                <template v-else>Buchungsvorlage ID {{ id }} </template>
            </h2>
            <div class="fibu-buchungsstapel-vorlage-fields">
                <FormGroupBuilder
                    v-if="isNew || data.id"
                    :fields="ioFields"
                    :data="data"
                    :refresh="validationRefresh"
                />

                <template v-if="isNew">
                    <b-button
                        type="submit"
                        class="total-btn mr-1"
                        variant="primary"
                        :disabled="busy"
                        @click="dataProvide"
                    >
                        <template v-if="!busy">anlegen</template>
                        <template v-else>
                            <Spinner small variant="light" />
                        </template>
                    </b-button>
                </template>
                <template v-else>
                    <b-button
                        type="submit"
                        class="total-btn mr-1"
                        variant="primary"
                        :disabled="busy"
                        @click="dataProvide"
                    >
                        <template v-if="!busy">Speichern</template>
                        <template v-else>
                            <Spinner small variant="light" />
                        </template>
                    </b-button>
                </template>

                <b-button
                    v-if="isNew"
                    type="cancel"
                    :to="`/fibu/buchungsstapel/verwalten/${id}`"
                    class="total-btn"
                    variant="outline-secondary"
                >
                    <template v-if="checkRight('write')">Abbrechen</template>
                    <template v-else>Zurück</template>
                </b-button>

                <b-button
                    v-else
                    type="cancel"
                    :to="`/fibu/buchungsstapel/verwalten/${bsId}`"
                    class="total-btn"
                    variant="outline-secondary"
                >
                    <template v-if="checkRight('write')">Abbrechen</template>
                    <template v-else>Zurück</template>
                </b-button>


            </div>
        </div>
    </MainContainer>
</template>

<script>
import Toaster from "@/mixins/Toaster/Toaster";
import Rights from "@/mixins/Rights/Rights";
import Validation from "@/mixins/Validation/Validation";
import { ApiFactory } from "@/api/ApiFactory.js";
import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";
import Spinner from "@/components/Spinner/Spinner";
import MainContainer from "@/components/MainContainer/MainContainer";

const FiBuBuchungApi = ApiFactory.get("fibuBuchung");
const FiBuFinanzkontoApi = ApiFactory.get("fibuFinanzkonto");
const FiBuBuchungskontoApi = ApiFactory.get("fibuBuchungskonto");
const FiBuCategoryApi = ApiFactory.get("fibuCategory");
const FiBuVerwendungszweckApi = ApiFactory.get("fibuVerwendungszweck");
const FiBuBuchungsvorlageApi = ApiFactory.get("fibuBuchungsvorlage");

export default {
    name: "FiBuBuchungsvorlage",
    mixins: [Toaster, Rights, Validation],
    components: {
        MainContainer,
        FormGroupBuilder,
        Spinner
    },
    data() {
        return {
            id: this.$route.params.id,
            bsId: this.$route.params.bsid,
            ioFields: {
                finanzkonto_id: {
                    key: "finanzkonto_id",
                    label: "Finanzkonto",
                    type: "filteredselect",
                    options: []
                },
                buchungskonto_id: {
                    key: "buchungskonto_id",
                    label: "Buchungskonto",
                    type: "filteredselect",
                    options: []
                },
                verwendungszweck_switch: {
                    key: "verwendungszweck_switch",
                    label: "Verwendungszweck",
                    description: "Eigenen Verwendungszweck angeben",
                    type: "checkbox"
                },
                verwendungszweck: {
                    key: "verwendungszweck",
                    label: "",
                    type: "filteredselect",
                    options: []
                },
                verwendungszweck_text: {
                    key: "verwendungszweck_text",
                    label: "",
                    disabled: true
                },
                categories: {
                    key: "categories",
                    label: "Kategorien",
                    type: "checkboxselect",
                    options: [],
                    selectSize: 5,
                    sortActive: true
                },
                hr_relations: {
                    key: "hr_relations",
                    type: "hr"
                },
                betrag: {
                    key: "betrag",
                    label: "Betrag",
                    type: "fibuamountinput"
                },
                hr_betrag: {
                    key: "hr_betrag",
                    type: "hr"
                },
                mitglied_id: {
                    key: "mitglied_id",
                    label: "Mitglied/Kontakt",
                    type: "mitgliederselect"
                },
                remove_mitglied_rel: {
                    key: "remove_mitglied_rel",
                    label: "",
                    type: "button",
                    buttonText: "Mitglied entfernen",
                    handler: {
                        click: val => this.removeMitgliedRel()
                    }
                },
                vorname: {
                    key: "vorname",
                    label: "Vorname",
                    type: "mitgliederinputForBV",
                    disabled: false
                },
                nachname: {
                    key: "name",
                    label: "Name",
                    type: "mitgliederinputForBV",
                    disabled: false
                },
                new_mitglied_street: {
                    key: "strasse",
                    label: "Straße",
                    type: "mitgliederinputForBV",
                    disabled: false
                },
                new_mitglied_plz: {
                    key: "plz",
                    label: "PLZ",
                    type: "mitgliederinputForBV",
                    disabled: false
                },
                new_mitglied_city: {
                    key: "ort",
                    label: "Ort",
                    type: "mitgliederinputForBV",
                    disabled: false
                },
                new_mitglied_email: {
                    key: "email",
                    label: "E-Mail",
                    type: "mitgliederMailInputForBV",
                    disabled: false
                },
            },
            data: {
                contact: {}
            },
            busy: false,
            finanzkonto: {
                busy: false,
                items: [],
                options: []
            },
            buchungskonto: {
                busy: false,
                items: [],
                options: []
            },
            category: {
                busy: false,
                items: [],
                options: []
            },
            verwendungszweck: {
                busy: false,
                items: [],
                options: []
            }
        }
    },
    created() {
        this.fetchFinanzkonto();
        this.fetchBuchungskonto();
        this.fetchCategory();
        this.fetchVerwendungszweck();

        if (!this.isNew) {
            this.fetch();
        }
    },
    methods: {
        async fetch() {
            this.busy = true;

            const response = await FiBuBuchungsvorlageApi.getBuchungsvorlage(this.id, this.bsId);
            if (response.ok) {
                this.registerRights(response);
                this.cleanPayload(response.json);
                const data = response.json;
                data.categories = data.categories.map(item => item);
                const verwendungszweckItem = this.category.items.find(
                    item => item.text == data.verwendungszweck
                );
                if (verwendungszweckItem) {
                    data.verwendungszweck = verwendungszweckItem.id;
                    data.verwendungszweck_switch = false;
                } else {
                    data.verwendungszweck_text = data.verwendungszweck;
                    data.verwendungszweck_switch = true;
                }

                data.contact = {
                    vorname: null,
                    name: null,
                    strasse: null,
                    plz: null,
                    ort: null,
                    email: null
                }

                this.data = data;
            }
            this.busy = false;
        },
        async fetchFinanzkonto() {
            this.finanzkonto.busy = true;
            const response = await FiBuFinanzkontoApi.get();
            if (response.ok) {
                this.finanzkonto.items = response.json.collection;
                const options = response.json.collection.map(item => {
                    return {
                        text: `${item.kontonr} - ${item.text}`,
                        value: item.id
                    };
                });
                this.finanzkonto.options = options;
                this.ioFields.finanzkonto_id.options = options;
            }
            this.finanzkonto.busy = false;
        },
        async fetchBuchungskonto() {
            this.buchungskonto.busy = true;
            const response = await FiBuBuchungskontoApi.get();
            if (response.ok) {
                this.buchungskonto.items = response.json.collection;
                const options = response.json.collection.map(item => {
                    return {
                        text: `${item.kontonr} - ${item.text}`,
                        value: item.id
                    };
                });
                this.buchungskonto.options = options;
                this.ioFields.buchungskonto_id.options = options;
            }
            this.buchungskonto.busy = false;
        },
        async fetchCategory() {
            this.category.busy = true;
            const response = await FiBuCategoryApi.get();
            if (response.ok) {
                this.category.items = response.json.collection;
                const options = response.json.collection.map(item => {
                    return {
                        text: item.description,
                        value: item.id
                    };
                });
                this.category.options = options;
                this.ioFields.categories.options = options;
            }
            this.category.busy = false;
        },
        async fetchVerwendungszweck() {
            this.verwendungszweck.busy = true;
            const response = await FiBuVerwendungszweckApi.get();
            if (response.ok) {
                this.verwendungszweck.items = response.json.collection;
                const options = response.json.collection.map(item => {
                    return {
                        text: item.text,
                        value: item.id
                    };
                });
                this.verwendungszweck.options = options;
                this.ioFields.verwendungszweck.options = options;
            }
            this.verwendungszweck.busy = false;
        },
        async dataProvide() {
          this.busy = false;

            let response = null;
            if(this.isNew) {
                response = await FiBuBuchungsvorlageApi.post(this.data, this.id)
            } else {
                response = await FiBuBuchungsvorlageApi.put(this.data, this.id);
            }

            if(response.ok) {
                this.cleanValidationData(this.ioFields);
                this.makeToast('Erfolgreich gespeichert',
                    'Die Änderungen wurden erfolgreich in der Datenbank gespeichert.'
                );

                if(this.isNew) {
                    this.$router.push({
                        path: `/fibu/buchungsstapel/verwalten/${this.id}`
                    });
                } else {
                    this.$router.push({
                        path: `/fibu/buchungsstapel/verwalten/${response.json.collection[0]}`
                    });
                }
            } else {
                this.handleValidationData(response, this.ioFields);
            }
            this.busy = false;
        },
        cleanPayload(json) {
            Object.keys(json).forEach(key => {
                if (key.startsWith("_")) {
                    delete json[key];
                }
            });
        },
        removeMitgliedRel() {
            this.data.mitglied_id = null;
        }
    },
    computed: {
        isNew() {
            return this.$route.path.includes('new');
        }
    },
    watch: {
        "data.verwendungszweck_switch": {
            handler(val) {
                this.ioFields.verwendungszweck.disabled = val;
                this.ioFields.verwendungszweck_text.disabled = !val;
                if (val) this.data.verwendungszweck = null;
                if (!val) this.data.verwendungszweck_text = null;
            }
        },
        "data.mitglied_id": {
            handler(val) {
                if (val) {
                    this.ioFields.vorname.disabled = true;
                    delete this.data.vorname;
                    this.ioFields.nachname.disabled = true;
                    delete this.data.nachname;
                    this.ioFields.new_mitglied_street.disabled = true;
                    delete this.data.new_mitglied_street;
                    this.ioFields.new_mitglied_city.disabled = true;
                    delete this.data.new_mitglied_city;
                    this.ioFields.new_mitglied_email.disabled = true;
                    delete this.data.new_mitglied_email;
                    this.ioFields.new_mitglied_plz.disabled = true;
                    delete this.data.new_mitglied_plz;
                } else {
                    this.ioFields.vorname.disabled = false;
                    this.ioFields.nachname.disabled = false;
                    this.ioFields.new_mitglied_street.disabled = false;
                    this.ioFields.new_mitglied_city.disabled = false;
                    this.ioFields.new_mitglied_email.disabled = false;
                    this.ioFields.new_mitglied_plz.disabled = false;
                }
            },
            immediate: true
        }
    },

}
</script>

<style scoped>

</style>